import { call, put, takeLatest } from 'redux-saga/effects';
import {PAYMENT_INTEGRITY_DETAILS_REQUEST} from '@src/middleware/actions/actionTypes';
import { getPaymentIntegrityDetailsData } from '@src/middleware/services/reimbusement/paymentIntegrity/paymentIntegrityDetails.service';
import { fetchPaymentIntegrityDetailsError, fetchPaymentIntegrityDetailsSuccess, isLoadingDetails } from '@src/middleware/actions/Reimbursement/paymentIntegrityDetailsActions';

function* fetchPaymentIntegrityDetails(action: any) {
  try {
    yield put(isLoadingDetails(true));
    const response = yield call(getPaymentIntegrityDetailsData, action.payload);
    
    if (response && response?.Data && response?.Data?.length > 0) {
      yield put(fetchPaymentIntegrityDetailsSuccess(response.Data));
    } else {
      yield put(fetchPaymentIntegrityDetailsError(true));
    }
  } catch (error: any) {
    yield put(fetchPaymentIntegrityDetailsError(true));
  } finally {
    yield put(isLoadingDetails(false));
  }
}


export function* paymentIntegrityDetailsSaga() {
  yield takeLatest(PAYMENT_INTEGRITY_DETAILS_REQUEST, fetchPaymentIntegrityDetails);
}